/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Playing_DurationInputs */

const en_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 holes`)
};

const es_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 hoyos`)
};

const de_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 Löcher`)
};

const zh_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 洞`)
};

const ar_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 حفر`)
};

const fr_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 trous`)
};

const vi_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 hố`)
};

const sw_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mashimo 9`)
};

const th_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 หลุม`)
};

const bs_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 rupa`)
};

const ja_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9ホール`)
};

const ko_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9홀`)
};

const pt_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 buracos`)
};

const it_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 buche`)
};

const sv_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 hål`)
};

const nl_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 gaten`)
};

const da_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 huller`)
};

const nb_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 hull`)
};

const fi_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 reikää`)
};

const pl_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 dołków`)
};

const ru_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 лунок`)
};

const tr_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 delik`)
};

const hi_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 होल`)
};

const id_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 lubang`)
};

const ms_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 lubang`)
};

const cs_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 jamek`)
};

const el_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 τρύπες`)
};

const he_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 גומות`)
};

const af_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 gate`)
};

const hu_lessons_format_playing_duration = /** @type {(inputs: Lessons_Format_Playing_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9 lyuk`)
};

/**
* | output |
* | --- |
* | "9 holes" |
*
* @param {Lessons_Format_Playing_DurationInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_playing_duration = /** @type {((inputs?: Lessons_Format_Playing_DurationInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Playing_DurationInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_playing_duration(inputs)
	if (locale === "de") return de_lessons_format_playing_duration(inputs)
	if (locale === "zh") return zh_lessons_format_playing_duration(inputs)
	if (locale === "ar") return ar_lessons_format_playing_duration(inputs)
	if (locale === "fr") return fr_lessons_format_playing_duration(inputs)
	if (locale === "vi") return vi_lessons_format_playing_duration(inputs)
	if (locale === "sw") return sw_lessons_format_playing_duration(inputs)
	if (locale === "th") return th_lessons_format_playing_duration(inputs)
	if (locale === "bs") return bs_lessons_format_playing_duration(inputs)
	if (locale === "ja") return ja_lessons_format_playing_duration(inputs)
	if (locale === "ko") return ko_lessons_format_playing_duration(inputs)
	if (locale === "pt") return pt_lessons_format_playing_duration(inputs)
	if (locale === "it") return it_lessons_format_playing_duration(inputs)
	if (locale === "sv") return sv_lessons_format_playing_duration(inputs)
	if (locale === "nl") return nl_lessons_format_playing_duration(inputs)
	if (locale === "da") return da_lessons_format_playing_duration(inputs)
	if (locale === "nb") return nb_lessons_format_playing_duration(inputs)
	if (locale === "fi") return fi_lessons_format_playing_duration(inputs)
	if (locale === "pl") return pl_lessons_format_playing_duration(inputs)
	if (locale === "ru") return ru_lessons_format_playing_duration(inputs)
	if (locale === "tr") return tr_lessons_format_playing_duration(inputs)
	if (locale === "hi") return hi_lessons_format_playing_duration(inputs)
	if (locale === "id") return id_lessons_format_playing_duration(inputs)
	if (locale === "ms") return ms_lessons_format_playing_duration(inputs)
	if (locale === "cs") return cs_lessons_format_playing_duration(inputs)
	if (locale === "el") return el_lessons_format_playing_duration(inputs)
	if (locale === "he") return he_lessons_format_playing_duration(inputs)
	if (locale === "af") return af_lessons_format_playing_duration(inputs)
	if (locale === "hu") return hu_lessons_format_playing_duration(inputs)
	return en_lessons_format_playing_duration(inputs)
});